import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as
  | string
  | undefined;

if (!supabaseUrl || !publishableKey) {
  throw new Error(
    "VITE_SUPABASE_URL og VITE_SUPABASE_PUBLISHABLE_KEY verða að vera stillt.",
  );
}

export const supabase = createClient(supabaseUrl, publishableKey, {
  auth: {
    flowType: "pkce",
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
